/**
 * Controlled labeled checkbox: renders a text label next to a styled checkbox
 * input. Props: label, checked, onChange(checked), optional className/disabled.
 * Used in the admin AI submission-verification extracted-data form.
 */
import React from "react";

interface CheckboxFieldProps {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    className?: string;
    disabled?: boolean;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
    label,
    checked,
    onChange,
    className = "",
    disabled = false,
}) => {
    return (
        <div className={`flex items-center space-x-4 ${className}`}>
            <label className="text-sm font-medium tracking-widest">{label}</label>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
                className={`w-5 h-5 rounded border-gray-300 text-slate-900 focus:ring-slate-900 accent-slate-900 ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
            />
        </div>
    );
};

export default CheckboxField;
